
import "../AuthMobile.less";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { useAuth } from "../../../../hooks/auth/AuthContext";
import { formatUrlCurrencyLang } from "../../../../shared/helpers/general-helpers";

interface Props {
    backToFirstPage: () => void;
}

const RegisterMobileStep3 = ({ backToFirstPage }: Props) => {
    const navigate = useNavigate();
    const { authState } = useAuth();

    const goDepositPage = () => {
        navigate(`/`);
    }

    return (
        <>
            <div className="m-register-form-title"><FormattedMessage id={authState.isLogin ? 'AUTH_REGISTER_STEP3' : 'AUTH_REGISTER_STEP3_FAILED'} /></div>
            <div className="m-register-form-item">
                <FormattedMessage id={authState.isLogin ? 'AUTH_REGISTER_SUCCESS' : 'AUTH_REGISTER_FAILED'} />
            </div>
            <Button block type="primary" htmlType="submit" className="m-register-btn" onClick={authState.isLogin ? goDepositPage : backToFirstPage} >
                <FormattedMessage id={authState.isLogin ? "AUTH_REGISTER_BTN_DEPOSIT" : 'AUTH_REGISTER_BACK_FIRST'} />
            </Button>
        </>
    );
};

export default RegisterMobileStep3;
